// /opt/ptg01-v1/front-extranet/app/(dashboard)/layout.tsx
'use client';

import Sidebar from '@/components/Sidebar';
import TopBar from '@/components/TopBar';
import BottomTabBar from '@/components/BottomTabBar';
import QuickActionsFab from '@/components/QuickActionsFab';
import CommandPaletteHost from '@/components/CommandPaletteHost';
import AuthGuard from '@/components/AuthGuard';
import IdleTimeout from '@/components/IdleTimeout';
import { AuthProvider } from '@/lib/AuthContext';
import { QueryProvider } from '@/lib/QueryProvider';
import { TopBarOverrideProvider } from '@/lib/TopBarOverrideContext';
import { ToastProvider } from '@/lib/ToastContext';

export default function DashboardLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <QueryProvider>
            <AuthProvider>
                <AuthGuard requireActive={true}>
                    <IdleTimeout />
                    <TopBarOverrideProvider>
                        <ToastProvider>
                            <div className="flex h-screen overflow-hidden bg-white">
                                <Sidebar />
                                <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                                    <TopBar />
                                    <main className="flex-1 overflow-y-auto mt-20 lg:ml-[260px] pb-[calc(64px+env(safe-area-inset-bottom))] lg:pb-0">
                                        {children}
                                    </main>
                                </div>
                                <BottomTabBar />
                                <QuickActionsFab />
                                <CommandPaletteHost />
                            </div>
                        </ToastProvider>
                    </TopBarOverrideProvider>
                </AuthGuard>
            </AuthProvider>
        </QueryProvider>
    );
}
